// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"e97fd4a7","601":"325de0f2","972":"7f9ea225","976":"cceac80c"}[chunkId] + ".chunk.js";
};